import React from 'react';
import Tooltip from 'react-tooltip-lite';
import { useTranslation } from 'react-i18next';
import { FaEdit, FaEye } from 'react-icons/fa';
import { DELAY_HTOOLTIP } from 'global/Global';

interface IViewButton {
  onClick?: () => void;
  title?: any;
  hidden?: boolean;
}

export default function ViewButton(props: IViewButton) {
  const { t } = useTranslation();
  return (
    <>
      <Tooltip
        direction="down"
        eventOff="onClick"
        content={props.title || t('Table.Tooltip.Show')}
        hoverDelay={DELAY_HTOOLTIP}
        className={props.hidden ? 'invisible' : ''}
      >
        <FaEye
          onClick={props.onClick}
          color="#05c"
          size={18}
          className={`${props.hidden ? 'invisible' : ''} cursor-pointer`}
        />
      </Tooltip>
    </>
  );
}
